export const EmailPatvirtinimas = (email = '', t) => {
    const subject = t('ivairove_patvirtintas_acc')
    const html = `<div className="email Ivairove Patvirtinimas">
            <p style='font-size=13px;'>${t('email_patvirtinimas_1')}</p>
            <p style='font-size=13px;'>${t('email_patvirtinimas_2')}</p>
            <p style='font-size=13px;'>${t('email_patvirtinimas_3')}</p>
            <p style='font-size=13px;'>${t('email_patvirtinimas_4')} <a style='font-size=13px; color:black;' href='mailto:diversity@diversity.lt'>${t('email_patvirtinimas_email')}</a></p>
            <p style='font-size=13px;'>${t('email_patvirtinimas_5')}</p>
            <p style='font-size=13px;'>${t('email_patvirtinimas_6')}</p>
        </div>`;

    return {
        to: email,
        subject: subject,
        html: html,
    }
}
// export const EmailNaujoSuKodu = (code = '', t) => {
//     const subject = t('Vartotojas patvirtintas')
//     const html = `<div className="email Ivairove Patvirtinimas">
//             <p style='font-size=13px;'>${t('email_patvirtinimas_1')}</p>
//             <p style='font-size=13px;'>${t('email_patvirtinimas_2')}</p>
//             <p style='font-size=13px;'>${t('email_patvirtinimas_3')}</p>
//             <p style='font-size=13px;'>${t('email_patvirtinimas_4')} <a style='font-size=13px; color:black;' href='mailto:diversity@diversity.lt'>${t('email_patvirtinimas_email')}</a></p>
//             <p style='font-size=13px;'>${t('email_patvirtinimas_5')}</p>
//             <p style='font-size=13px;'>${t('email_patvirtinimas_6')}</p>
//         </div>`;

//     return {
//         html: html,
//     }
// }
export const EmailUzsiregistravoIAdmin = (data, t) => {
    const subject = t('Prisiregistravo nauja įmonė')
    const html = `<div className="email Ivairove">
            <p>Prisiregistravo nauja įmonė ${data.email}</p>
            <p><a href="https://vertinimas.diversity.lt">https://vertinimas.diversity.lt</a></p>
        </div>`;
    return {
        // to: email,
        subject: subject,
        html: html,
    }
}